export const dateFormatter = new Intl.DateTimeFormat(undefined, {
  month: 'short',
  day: 'numeric',
});

/** Date and time, e.g. for "last updated" timestamps in tables. */
export const dateTimeFormatter = new Intl.DateTimeFormat(undefined, {
  year: '2-digit',
  month: 'numeric',
  day: 'numeric',
  hour: 'numeric',
  minute: 'numeric',
});

const dateRangeFormatter = new Intl.DateTimeFormat(undefined, {
  month: 'short',
  day: 'numeric',
  year: 'numeric',
});

// Use `formatRange` or fallback if not supported by browser
export function formatDateRange(start: Date, end: Date) {
  if (dateRangeFormatter.formatRange) {
    return dateRangeFormatter.formatRange(start, end);
  } else {
    return `${dateRangeFormatter.format(start)} - ${dateRangeFormatter.format(end)}`;
  }
}
